import type { QueryParamConfig, QueryParamOptions } from 'use-query-params';
// eslint-disable-next-line no-restricted-imports -- this file is the useNoddiQueryParam wrapper the ban points callers to
import { useQueryParam } from 'use-query-params';

/**
 * Wrapper around useQueryParam that defaults to 'replaceIn' updateType
 * to prevent adding entries to browser history when changing query parameters.
 */
export const useNoddiQueryParam = <TypeToEncode, TypeFromDecode = TypeToEncode>(
  name: string,
  paramConfig?: QueryParamConfig<TypeToEncode, TypeFromDecode>,
  options?: QueryParamOptions
) => {
  return useQueryParam(name, paramConfig, {
    updateType: 'replaceIn',
    ...options
  });
};
